import styled from 'styled-components';

export const ScrollArea = styled.div`
  float: left;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const ScrollContainer = styled.div`
  float: left;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow-y: auto;
`;

export const ScrollContent = styled.div`
  width: 100%;
  float: left;
  height: auto;
`;

export const Left = styled.div`
  width: 30rem;
  float: left;
  height: 100%;
  background: ${({ theme }) => theme.colors.BG1};
  border-style: dashed;
  border-width: 0px;
  border-left-width: 3px;
  border-color: ${({ theme }) => theme.colors.BORDER};

  @media (max-width: 1024px) {
    padding: 0px 0 0 0;
    z-index: 5000;
    width: 100%;
    left: 0px;
    top: 0px;
    border: none;
  }

`;
